import React from 'react';
import {useTranslation} from 'react-i18next';
import {ControlButton, TscButtonType, TscThemeNames} from '@techsmith/tsc-cloud-style-guide';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {themeStore} from '../../context/themeProvider';
import styled from 'styled-components';
import {IFolderTreeNode} from '../../model/folderTreeNode';
import {IMediaDetails} from '../../model/mediaDetails';
import {batchSelectionStore, clearBatchSelection} from '../../context/batchSelectionProvider';

export const BatchSelectionContainer = styled.div`
   margin-right: .5rem;
`;

export const BatchSelectionIndicatorBase: React.FC<IStateMappedProps> = ({theme, selectedFolders, selectedMedia}) => {
   const {t} = useTranslation();

   let selectionMessage;
   const selectedItemsCount = selectedFolders.length + selectedMedia.length;
   const hasSelectedItems = selectedItemsCount > 0;
   const itemCountMessage = t('library.multiSelect.itemCountMessage', {itemCount: selectedItemsCount});
   const foldersMessage = selectedFolders.length === 1 ? t('library.multiSelect.singleFolderMessage') : t('library.multiSelect.foldersMessage', {numFolders: selectedFolders.length});
   const mediaMessage = t('library.multiSelect.mediaMessage', {numMedia: selectedMedia.length});
   if (selectedFolders.length && selectedMedia.length) {
      selectionMessage = itemCountMessage;
   } else if (selectedFolders.length) {
      selectionMessage = foldersMessage;
   } else {
      selectionMessage = mediaMessage;
   }

   return hasSelectedItems ? (
      <BatchSelectionContainer>
         <ControlButton
            buttonType={TscButtonType.secondary}
            themeName={theme}
            onClick={clearBatchSelection}
            title={t('library.multiSelect.clearSelectionTitle')}
            label={t('library.multiSelect.clearSelectionLabel', {selectionMessage: selectionMessage})}
         />
      </BatchSelectionContainer>
   ) :
      null;
};

export interface IStateMappedProps {
   theme: TscThemeNames;
   selectedFolders: IFolderTreeNode[];
   selectedMedia: IMediaDetails[];
}

const mapStatesToProps = (
   // eslint-disable-next-line no-empty-pattern
   {},
   {theme}: Partial<IStateMappedProps>,
   {selectedFolders, selectedMedia}: Partial<IStateMappedProps>
): IStateMappedProps => ({theme, selectedFolders, selectedMedia});

export default withMemoizedContexts(mapStatesToProps, themeStore, batchSelectionStore)(BatchSelectionIndicatorBase);
